import React from 'react';
import http from '../api';
import PopupFrameV2 from '../popup/PopupFrameV2';
import Button from './Button';

export class FirstIntroPopup extends React.Component {
    constructor(props) {
		super(props);
		this.state = {
        }
    }

    componentWillMount() {
    }

	componentDidMount() {
    
    }

    componentDidUpdate() {
    
    }

    componentWillUnmount(e) {
    
    }

    render() {
        return (
            <div>
                <div className="FirstIntroPopup" style={{position:"fixed", zIndex: 99999}}>
                    <PopupFrameV2
                            className={"FirstIntroPopupFrame"}
                            width={"auto"}
                            maxWidth={"90vw"}
                            // height={"90vh"}
                            maxHeight={"90vh"}
                            padding={"40px 0px 0px 0px"}
                            onClose={() => {
                                this.props.onClose(); // 상위에서 showFirstIntroPopup=false 처리
                            }}
                        >
                        <div className="flexBox" style={{flexDirection:'column', flexWrap:"nowrap", height:"100%", textAlign:"center", alignItems: "center"}}>
                            <div className="flexBox" style={{flex:"1", flexDirection:'column', flexWrap:"nowrap", textAlign:"center", alignItems: "center", padding:"0px 40px 0px 40px"}}>
                                <div style={{display:"flex", alignItems: "center"}}>
                                    <img className="logo" src="https://s3.ap-northeast-2.amazonaws.com/otdeal.file/0e962a7a54a126f4e37dde4810da9e4f7ad6f91e.png" style={{width:"100px", height:"auto"}}/>
                                    <div style={{display: "flex", alignItems: "center", marginLeft: "10px"}}>
                                        <div className="title" style={{fontWeight: "700", fontSize: "24px", fontFamily:"Roboto Flex", marginRight:"80px"}}>안녕하세요. 인공지능 로보MD예요.</div>
                                    </div>
                                </div>
                                <div className="content" style={{display:"flex", overflow:"auto", fontSize:"16px", fontWeight:"600", fontFamily:"Roboto Flex",  marginTop:"30px"}}>
                                <>
                                    {sessionStorage.getItem("userName")}님, 반갑습니다.<br />
                                    앞으로 제가 쇼핑몰의 트렌드분석, 통계, 디자인, 팝업, 상품추천을<br />
                                    운영하면서 구매전환율을 높여 드릴게요~<br />
                                    사용을 위해 제가 잘 활동하도록 설정을 해주셔야 해요~<br />
                                    그럼 우선 원하시는 서비스와 데이터를 연동을 선택해주세요
                                </>
                                </div>
                            </div>
                            <div className='flexBox' style={{width: "100%", justifyContent: "center", height:"auto", marginTop: "50px"}}>
                                <div id="button" onClick={() => {
                                    this.props.onClose(); // 상위에서 showFirstIntroPopup=false 처리
                                }}>{
                                    "예"
                                }</div>
                            </div>
                        </div>
                    </PopupFrameV2>
                </div>
            </div>
        )
    };
}